<template>
    <div id="error-page">
        <div class="content">
            <h2 class="header" data-text="403" style="background: transparent;">
                403
            </h2>
            <h4 data-text="Forbidden! Access Denied">
                Forbidden! Access Denied
            </h4>
            <p>
                Please contract to the adminstrator
            </p>
        </div>
    </div>
</template>
<script lang="ts">
import './AccessDeniedComponent.css';
import { defineComponent } from 'vue';

export default defineComponent({
    created() {
    },
    data() {
        return {
        }
    },
    mounted() {
        
    },
    methods: {
        
    }
});
</script>
